/**
 * Cart Integration Script
 * Integrates cart popup with existing add to cart functionality
 */

// Store reference to original updateCart function
let originalUpdateCart = null;

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  // Store original updateCart function
  setTimeout(() => {
    originalUpdateCart = window.updateCart;
  }, 50);

  // Initialize special product info object
  if (!window.specialProducts) {
    window.specialProducts = {};
  }

  // Add getProductInfo function to window
  window.getProductInfo = async function() {
    try {
      const response = await fetch('/?sections=cart-popup');
      const sections = await response.json();
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = sections['cart-popup'];
      const productInfoScript = tempDiv.querySelector('[data-product-info]');
      if (productInfoScript) {
        return JSON.parse(productInfoScript.textContent);
      }
    } catch (e) {
      console.error('Error getting product info:', e);
    }
    return {};
  };

  interceptAddToCartForms();
  
  // Initialize cart count on page load
  setTimeout(() => {
    if (window.updateCartCountDirect) {
      window.updateCartCountDirect();
    }
  }, 500);
});

function interceptAddToCartForms() {
  document.addEventListener('click', function(event) {
    const addToCartButton = event.target.closest('[data-product-atc]');
    if (!addToCartButton) return;

    const form = addToCartButton.closest('form');
    if (!form) return;

    const productData = extractProductDataFromForm(form);
    
    window.lastAddedProduct = productData;
    
    if (productData.productId && (productData.hasFabricTag || productData.hasMinimumQuantity)) {
      window.specialProducts[productData.productId] = {
        hasFabricTag: productData.hasFabricTag,
        hasMinimumQuantity: productData.hasMinimumQuantity
      };
    }
    
    setupCartSuccessDetection();
  });

  setTimeout(() => {
    const themeUpdateCart = window.updateCart;
    
    window.updateCart = function() {
      // Always call the original updateCart first
      if (originalUpdateCart) {
        originalUpdateCart();
      }
      
      // Then apply our special cart count logic
      setTimeout(() => {
        if (window.updateCartCountDirect) {
          window.updateCartCountDirect();
        }
      }, 50);
      
      // Show popup if we have a pending product addition
      if (window.lastAddedProduct) {
        const event = new CustomEvent('cartItemAdded', {
          detail: window.lastAddedProduct
        });
        document.dispatchEvent(event);
        
        window.lastAddedProduct = null;
      }
    };
  }, 200);
}

function setupCartSuccessDetection() {
  let initialCartItemCount = null;
  
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      initialCartItemCount = cart.item_count;
    })
    .catch(() => {
      const cartCountElement = document.querySelector('[data-header-cart-count]');
      if (cartCountElement) {
        const text = cartCountElement.textContent.trim();
        initialCartItemCount = text ? parseInt(text.replace(/[()]/g, '')) : 0;
      }
    });

  const checkCartSuccess = () => {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (cart.item_count > initialCartItemCount && window.lastAddedProduct) {
          
          setTimeout(() => {
            if (window.updateCartCountDirect) {
              window.updateCartCountDirect();
            }
          }, 100);
          
          const event = new CustomEvent('cartItemAdded', {
            detail: window.lastAddedProduct
          });
          document.dispatchEvent(event);
          
          window.lastAddedProduct = null;
        } else if (window.lastAddedProduct) {
          window.lastAddedProduct = null;
        }
      })
      .catch(() => {
        const cartCountElement = document.querySelector('[data-header-cart-count]');
        if (cartCountElement) {
          const newText = cartCountElement.textContent.trim();
          const newCount = newText ? parseInt(newText.replace(/[()]/g, '')) : 0;
          
          if (newCount > initialCartItemCount && window.lastAddedProduct) {
            
            setTimeout(() => {
              if (window.updateCartCountDirect) {
                window.updateCartCountDirect();
              }
            }, 100);
            
            const event = new CustomEvent('cartItemAdded', {
              detail: window.lastAddedProduct
            });
            document.dispatchEvent(event);
            
            window.lastAddedProduct = null;
          } else if (window.lastAddedProduct) {
            window.lastAddedProduct = null;
          }
        }
      });
  };

  setTimeout(checkCartSuccess, 500);
  
  setTimeout(checkCartSuccess, 1500);

  const checkForErrorMessages = () => {
    const errorSelectors = [
      '.product-form__error-message',
      '.product-form__error',
      '.error-message',
      '[data-error-message]',
      '.alert--error',
      '.notice--error'
    ];
    
    for (const selector of errorSelectors) {
      const errorElement = document.querySelector(selector);
      if (errorElement && errorElement.textContent.trim() && window.lastAddedProduct) {
        window.lastAddedProduct = null;
        return true;
      }
    }
    return false;
  };

  setTimeout(checkForErrorMessages, 300);
  setTimeout(checkForErrorMessages, 800);
}

function extractProductDataFromForm(form) {
  const formData = new FormData(form);
  
  const productContainer = form.closest('[data-product-form]') || form.closest('[data-section-type]') || form;
  
  const productTitle = productContainer.querySelector('.product__heading')?.textContent || 
                      productContainer.querySelector('.product-details__title')?.textContent ||
                      productContainer.querySelector('[data-product-title]')?.textContent || 
                      document.querySelector('h1')?.textContent || 'Product';
  
  const productImage = productContainer.querySelector('.product-gallery img')?.src ||
                      productContainer.querySelector('[data-product-gallery] img')?.src ||
                      productContainer.querySelector('[data-product-image] img')?.src ||
                      document.querySelector('.product-gallery img')?.src ||
                      '/assets/placeholder.png';
  
  const productPrice = productContainer.querySelector('[data-product-price]')?.textContent ||
                      productContainer.querySelector('.product-price')?.textContent ||
                      productContainer.querySelector('.price')?.textContent ||
                      '';

  // Extract quantity from form
  const quantityInput = form.querySelector('input[name="quantity"]') || 
                       form.querySelector('[name="quantity"]') ||
                       form.querySelector('.quantity-field input') ||
                       form.querySelector('input[type="number"]');
  
  const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

  const variantSelect = form.querySelector('select[name="id"]');
  let variantText = '';
  
  if (variantSelect && variantSelect.selectedIndex > 0) {
    const selectedOption = variantSelect.options[variantSelect.selectedIndex];
    variantText = selectedOption.text.split(' - ').slice(1).join(' - ');
  }

  const hasFabricTag = form.dataset.hasFabricTag === 'true';
  const hasMinimumQuantity = form.dataset.minimumQuantityEnabled === 'true';
  
  return {
    title: productTitle.trim(),
    image: productImage,
    price: productPrice.trim(),
    variant: variantText || '',
    quantity: quantity,
    hasFabricTag: hasFabricTag,
    hasMinimumQuantity: hasMinimumQuantity,
    productId: formData.get('id')
  };
}
function extractNumberFromText(text) {
  const match = text.match(/\d+/);
  return match ? parseInt(match[0]) : 0;
}

window.checkForMinimumQuantityMetafield = function(productHandle) {
  const minQuantityInputs = document.querySelectorAll('.quantity-field[data-minimum-quantity-enabled="true"]');
  return minQuantityInputs.length > 0;
};

let cartCountUpdateTimeout = null;

window.updateCartCountDirect = async function() {
  if (cartCountUpdateTimeout) {
    clearTimeout(cartCountUpdateTimeout);
  }
  
  cartCountUpdateTimeout = setTimeout(async () => {
    try {
      const [cartResponse, productInfoResponse] = await Promise.all([
        fetch('/cart.js').then(res => res.json()),
        fetch('/?sections=cart-popup').then(res => res.json())
      ]);
      
      const cart = cartResponse;
      
      // Get fresh product info
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = productInfoResponse['cart-popup'];
      const productInfoScript = tempDiv.querySelector('[data-product-info]');
      const productInfo = productInfoScript ? JSON.parse(productInfoScript.textContent) : {};
      
      let displayCount = 0;
      
      for (const item of cart.items) {
        const itemInfo = productInfo[item.variant_id] || productInfo[item.product_id];
        const isFabricOrMinQty = itemInfo?.hasFabricTag || itemInfo?.hasMinimumQuantity;
        
        if (isFabricOrMinQty) {
          displayCount += 1;
        } else {
          displayCount += item.quantity;
        }
      }
      
      const headerCartCount = document.querySelector('[data-header-cart-count]');
      if (headerCartCount) {
        const currentText = headerCartCount.textContent.trim();
        const currentCount = currentText ? parseInt(currentText.replace(/[()]/g, '')) : 0;
        
        if (currentCount !== displayCount) {
          requestAnimationFrame(() => {
            if (displayCount > 0) {
              headerCartCount.textContent = `(${displayCount})`;
              headerCartCount.style.display = '';
            } else {
              headerCartCount.textContent = '';
              headerCartCount.style.display = 'none';
            }
          });
        }
      }
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }, 100);
};

// Listen for various cart update events from theme
document.addEventListener('cart:updated', () => {
  setTimeout(() => {
    if (window.updateCartCountDirect) {
      window.updateCartCountDirect();
    }
  }, 100);
});

// Listen for cart item additions/removals
document.addEventListener('cart:item-added', () => {
  setTimeout(() => {
    if (window.updateCartCountDirect) {
      window.updateCartCountDirect();
    }
  }, 100);
});

document.addEventListener('cart:item-removed', () => {
  setTimeout(() => {
    if (window.updateCartCountDirect) {
      window.updateCartCountDirect();
    }
  }, 100);
});

// Also listen for any cart changes via mutation observer on cart count element
const cartCountElement = document.querySelector('[data-header-cart-count]');
if (cartCountElement) {
  const observer = new MutationObserver(() => {
    // If the cart count was updated by the theme, apply our special logic
    setTimeout(() => {
      if (window.updateCartCountDirect) {
        window.updateCartCountDirect();
      }
    }, 50);
  });
  
  observer.observe(cartCountElement, {
    childList: true,
    characterData: true,
    subtree: true
  });
} 